import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "input"]
  static values = {
    placeholder: { type: String, default: "" }
  }

  connect() {
    this._renderLabel()
  }

  onCalendarChange(event) {
    const v = event?.target?.value
    if (typeof v !== "string") return
    this.inputTarget.value = v
    this._renderLabel()
  }

  clear() {
    this.inputTarget.value = ""
    this._renderLabel()
  }

  _renderLabel() {
    const v = this.inputTarget.value
    if (!v) {
      this.buttonTarget.textContent = this.placeholderValue || "—"
      return
    }

    const parts = v.split("-").map((x) => parseInt(x, 10))
    if (parts.length !== 3 || parts.some((n) => !Number.isFinite(n))) {
      this.buttonTarget.textContent = v
      return
    }

    const [year, month, day] = parts
    const date = new Date(year, month - 1, day)
    if (Number.isNaN(date.getTime())) {
      this.buttonTarget.textContent = v
      return
    }

    try {
      this.buttonTarget.textContent = date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      })
    } catch {
      this.buttonTarget.textContent = v
    }
  }
}

